// extracted by mini-css-extract-plugin
export default {"wrapper":"mo-z","reviewFormSuccess":"no-z","header":"oo-z","message":"po-z","paragraph":"qo-z","lottieContainer":"ro-z"};